import React, { useEffect, useState } from 'react';
import DefaultLoader from '../../../components/loader/DefaultLoader';
import axios from 'axios';
import {flatObject} from '../../../utils/flat';
import SeasonRecordComponent from '../../../components/record/SeasonRecordComponent';
import {useCookies} from 'react-cookie';
import dateSetting from '../../../utils/dateSetting';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ballImage from '../../../assets/img/icon/ball_icon.png';

function PlayerSeasonRecord({profile}) {
    const [cookies] = useCookies(['hiball_token']);
    const navigate = useNavigate();
    let dateObj = dateSetting();
    let [seasonRecord, setSeasonRecord] = useState({});
    let [season, setSeason] = useState(dateObj['season']);
    let {type} = profile;
    const { t } = useTranslation();
    
    useEffect(() => {
        let playerId = profile['playerId'];
        let params = {};

        if(type === 'batter') {
            params = {
                recordType: 'digestBattingRecord', recordName: 'seasonRecord',
                batterIds: playerId,
                gameTypeCode: 4201,
                authToken:JSON.stringify(cookies['hiball_token'])
            }

            const seasonParam = {...params, seasons: season};
            const beforeSeasonParam = {...params, seasons: season-1}

            const seasonPromise = fetchFunc(seasonParam);
            const beforeSeasonPromise = fetchFunc(beforeSeasonParam);

            Promise.all([
                seasonPromise, beforeSeasonPromise
            ]).then((response) => {
                const seasonData = response[0]['data']['result'][0];
                // const beforeSeasonData = response[1]['data']['result'][0];

                // if(seasonData['batter'] === null) {
                //     setSeasonRecord(flatObject(beforeSeasonData));
                // } else {
                //     setSeasonRecord(flatObject(seasonData));
                // }
                setSeasonRecord(flatObject(seasonData));
            });
        } else {
            params = {
                recordType: 'digestPitchingRecord', recordName: 'selectSeasonRecord',
                pitcherIds: playerId,
                gameTypeCode: 4201,
                authToken:JSON.stringify(cookies['hiball_token'])
            }

            const seasonParam = {...params, seasons: season};
            const beforeSeasonParam = {...params, seasons: season-1}

            const seasonPromise = fetchFunc(seasonParam);
            const beforeSeasonPromise = fetchFunc(beforeSeasonParam);

            Promise.all([
                seasonPromise, beforeSeasonPromise
            ]).then((response) => {
                const seasonData = response[0]['data']['result'][0];
                // const beforeSeasonData = response[1]['data']['result'][0];

                // if(seasonData === null) {
                //     setSeasonRecord(flatObject(beforeSeasonData));
                // } else {
                //     setSeasonRecord(flatObject(seasonData));
                // }
                setSeasonRecord(flatObject(seasonData));
            });
        }
    }, [season]);

    async function fetchFunc(params) {
        return new Promise((resolve, reject) => {
            axios({
                url : `${process.env.REACT_APP_API_URL}`,
                params
            }).then((result) => {
                resolve(result);
            });
        })
    }

    let recordString = '';

    if(type === 'batter') {
        recordString += (seasonRecord['basicStat_gameCnt'] || 0);
        // recordString += '경기 ';
        recordString += t('game') + " ";

        recordString += (seasonRecord['basicStat_tpa'] || 0);
        // recordString += '타석 ';
        recordString += t('pa') + ' ';

        recordString += `${seasonRecord['avg']}/${seasonRecord['obp']}/${seasonRecord['slg']}`;
    } else {
        recordString += (seasonRecord['basicStat_gameCnt'] || 0);
        // recordString += '경기 ';
        recordString += t('game') + " ";
        recordString += (seasonRecord['win'] || 0);
        // recordString += '승 ';
        recordString += t('win') + " ";
        recordString += (seasonRecord['lose'] || 0);
        // recordString += '패 ';
        recordString += t('lose') + " ";
        recordString += (seasonRecord['save'] || 0);
        // recordString += '세이브 ';
        recordString += t('save') + " ";
        recordString += (seasonRecord['hold'] || 0);
        // recordString += '홀드';
        recordString += t('hold');
    }

    if(Object.keys(seasonRecord).length === 0 ) {
        return <DefaultLoader />
    }

    function seasonHandler(event) {
        console.log("시즌 변경");
        let value = event.target.value;
        setSeason(value);
    }

    return (
        <div className="profileRecordBox">
            <div className="recordTitle">
                <img src={ballImage} style={{ height: "25px" }} alt='#'/>
                <Form.Group onChange={seasonHandler}>
                    <Form.Select size='sm' defaultValue={season}>
                        <option value={dateObj['season']-2}>{dateObj['season']-2}</option>
                        <option value={dateObj['season']-1}>{dateObj['season']-1}</option>
                        <option value={dateObj['season']}>{dateObj['season']}</option>
                    </Form.Select>
                </Form.Group>
                &nbsp;{t('seasonStats')}
                {/* {(seasonRecord['season'] || '')+" "+t('seasonStats')} */}
                <span className="dataRow">
                    {recordString}
                </span>
            </div>
            <div className="recordBox">
                <SeasonRecordComponent record={seasonRecord} type={type}/>
            </div>
        </div>
    )
}

export default PlayerSeasonRecord;